import * as React from "react";
const ConversationIcon = (props) => (
  <svg
    width={21}
    height={19}
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.158 2.79933C20.158 2.2535 19.9413 1.7303 19.5553 1.34493C19.1699 0.958872 18.6467 0.742188 18.1009 0.742188H3.01515C2.46932 0.742188 1.94613 0.958872 1.56076 1.34493C1.1747 1.7303 0.958008 2.2535 0.958008 2.79933V17.885C0.958008 18.1621 1.12533 18.4124 1.3811 18.5186C1.63755 18.6249 1.93241 18.566 2.12852 18.3698L6.04189 14.4565H18.1009C18.6467 14.4565 19.1699 14.2398 19.5553 13.8537C19.9413 13.4684 20.158 12.9452 20.158 12.3993V2.79933ZM18.7866 2.79933V12.3993C18.7866 12.581 18.7146 12.7559 18.5857 12.8841C18.4574 13.013 18.2826 13.085 18.1009 13.085H5.75801C5.57629 13.085 5.40212 13.157 5.27321 13.286L2.32944 16.2297V2.79933C2.32944 2.61762 2.40144 2.44276 2.53035 2.31453C2.65858 2.18562 2.83344 2.11362 3.01515 2.11362H18.1009C18.2826 2.11362 18.4574 2.18562 18.5857 2.31453C18.7146 2.44276 18.7866 2.61762 18.7866 2.79933Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.7866 2.79933V12.3993C18.7866 12.581 18.7146 12.7559 18.5857 12.8841C18.4574 13.013 18.2826 13.085 18.1009 13.085H5.75801C5.57629 13.085 5.40212 13.157 5.27321 13.286L2.32944 16.2297V2.79933C2.32944 2.61762 2.40144 2.44276 2.53035 2.31453C2.65858 2.18562 2.83344 2.11362 3.01515 2.11362H18.1009C18.2826 2.11362 18.4574 2.18562 18.5857 2.31453C18.7146 2.44276 18.7866 2.61762 18.7866 2.79933ZM11.2547 10.3422H5.76898C5.39047 10.3422 5.08327 10.035 5.08327 9.65647C5.08327 9.27796 5.39047 8.97076 5.76898 8.97076H11.2547C11.6332 8.97076 11.9404 9.27796 11.9404 9.65647C11.9404 10.035 11.6332 10.3422 11.2547 10.3422ZM15.369 6.2279H5.76898C5.39047 6.2279 5.08327 5.9207 5.08327 5.54219C5.08327 5.16367 5.39047 4.85647 5.76898 4.85647H15.369C15.7475 4.85647 16.0547 5.16367 16.0547 5.54219C16.0547 5.9207 15.7475 6.2279 15.369 6.2279Z"
      fill="black"
    />
  </svg>
);
export default ConversationIcon;
